import * as React from 'react'
import styled from 'styled-components'
import Container from '../frontend-lib/components/common/Container'
import Section from '../frontend-lib/components/common/Section'

const PrivacyPolicy_EN = () => {
  return (
    <>
      <Section>
        <Container>
          <Title>Personal Information Protection Policies</Title>
          <p>
            INVADE Co., Ltd. handles a large amount of personal information in the operation of the Company; to that
            end, the Company has established the Policies according to the Code of Ethical Practice of the Company, and
            has established a Personal Information Management System so that we can exercise our duties as a company.
          </p>
          <List>
            <ListItem>
              Policy 1. The Company is as specific as possible about the purposes of use of personal information, and
              shall appropriately handle it within the scope necessary for achieving said purposes. Also, the Company
              will take measures so that this information is not used for any other purposes.
            </ListItem>
            <ListItem>
              Policy 2. Personal information is collected using a legal and appropriate method.
            </ListItem>
            <ListItem>
              Policy 3. Personal information is not provided to third parties without the permission of the person in
              question.
            </ListItem>
            <ListItem>
              Policy 4. For the management of personal information, the Company works to take the necessary and
              appropriate measures to prevent and correct leakage, destruction, and damage, and to achieve other types
              of safety management.
            </ListItem>
            <ListItem>
              Policy 5. For the handling of personal information, the Company works to allow persons who have provided
              such information to be able to provide it appropriately, and works to keep such information as accurate
              and as up to date as possible.
            </ListItem>
            <ListItem>
              Policy 6. The Company complies with the laws and ordinances concerning personal information protection,
              and has established company regulations concerning personal information protection and will comply with
              them while making continuous revisions.
            </ListItem>
            <ListItem>
              Policy 7. The Company has established a contact center that handles complaints and inquiries concerning
              personal information, and works to handle them in an appropriate manner.
            </ListItem>
          </List>
          <MarginText>INVADE Co., Ltd.</MarginText>
          <MarginText>Director</MarginText>
          <MarginText>Kyohei Kaburagi</MarginText>
          <MarginText>(Supplementary Provisions)</MarginText>
          <MarginText>February 1, 2020 Enacted/enforced</MarginText>
        </Container>
        <Container>
          <Title>About Handling of Personal Information</Title>
          <p>
            INVADE Co., Ltd. (hereinafter “the Company”) has published the Privacy Policy to protect the privacy of user
            companies, partnership companies, organizations, etc. (hereinafter “user companies”) and users (hereinafter
            “users”) of the service provided based on the Privacy Policy (hereinafter “the Service”), and the Company
            shall carefully manage and handle the personal information of users (as defined below).
          </p>
        </Container>
        <Container>
          <Title>Personal Information</Title>
          <p>
            Personal information is information about users that can be used to identify them, such as: name, address,
            telephone number, e-mail address, company name, school name, etc. Also, it includes information that, while
            it cannot be used to identify individuals, can be easily compared with other information to effectively
            identify them.
          </p>
        </Container>
        <Container>
          <Title>Purposes of Use of Personal Information</Title>
          <p>
            The purposes of use of personal information are as follows. The Company shall not use personal information
            beyond the purposes of use.
          </p>
          <List>
            <ListItem>
              A. For personal identification of users and the provision of the Service to users
            </ListItem>
            <ListItem>
              B. For communications, e-mail newsletters, DMs , and transmission/sending of other types of notices in
              conjunction with use of the Service
            </ListItem>
            <ListItem>
              C. To provide personal information to user companies of the Service according to permission/application of
              users
            </ListItem>
            <ListItem>
              D. To transmit/display advertisements, content, etc. based on attribute information, device information,
              location information, behavior history, etc., and to provide the Service
            </ListItem>
            <ListItem>
              E. To improve the Service, develop new services, investigate and analyze the usage of points, and perform
              marketing
            </ListItem>
            <ListItem>
              F. For campaigns, surveys, monitoring, data collection, etc.
            </ListItem>
            <ListItem>
              G. To transmit URL information to senders of blank e-mails
            </ListItem>
            <ListItem>
              H. To confirm and respond to opinions concerning the service, inquiries, and information posted in online
              reviews
            </ListItem>
            <ListItem>
              I. To investigate behaviors prohibited in the Terms of Service, etc., such as applications for business
              engagement/diversion, duplicate applications, transfer of rights, registration of falsified information,
              and to perform a detailed confirmation of the contents thereof
            </ListItem>
          </List>
        </Container>
        <Container>
          <Title>About Address Information Provided by Users</Title>
          <p>
            INVADE Co., Ltd. (hereinafter “the Company”) has published the Privacy Policy to protect the privacy of user
            companies, partnership companies, organizations, etc. (hereinafter “user companies”) and users (hereinafter
            “users”) of the service provided based on the Privacy Policy (hereinafter “the Service”), and the Company
            shall carefully manage and handle the personal information of users (as defined below).
          </p>
        </Container>
        <Container>
          <Title>Voluntary Provision of Personal Information</Title>
          <p>You may not be able to use the Service unless you provide all of the items required for the Service.</p>
        </Container>
        <Container>
          <Title>Provision of Personal Information to Third Parties</Title>
          <p>
            The Company, in principle, shall not provide personal information to third parties without the permission of
            users. After the party to which the information is to be provided and the contents of the information to be
            provided are specified, the information shall be provided only when the permission of the user has been
            obtained.
          </p>
          <List>
            <ListItem>
              1. Party to which the information is to be provided, and the purposes<br/>
              Provided to user companies of the Service in order to provide services such as requests for materials,
              applications, reservations, purchases, etc.
            </ListItem>
            <ListItem>
              2. Items of personal information to be provided<br/>
              Pieces of information within the scope necessary for achieving the purposes of use, from information
              obtained from users (including service use history, and behavior history which includes view history,
              search history, bookmarks, etc.).
            </ListItem>
            <ListItem>
              3. Means and methods of provision
              <div>Sent or transmitted using written or electromagnetic methods.</div>
            </ListItem>
          </List>
          <MarginText>
            However, personal information can be provided without the permission of users within the scope that does not
            violate the relevant laws and ordinances.
          </MarginText>
          <List>
            <ListItem>
              A. When it has been determined that a user has caused loss to a third party
            </ListItem>
            <ListItem>
              B. When there are particularly necessary circumstances required for improving public health or promoting
              the healthy rearing of infants, and where it is difficult to obtain the permission of the user in question
            </ListItem>
            <ListItem>
              C. When it is necessary to cooperate in the execution of duties stipulated in laws and ordinances of a
              state organ, local public body, or entrusted person, and obtaining the permission of the user in question
              may hinder the execution of such duties
            </ListItem>
            <ListItem>
              D. When a request for disclose of personal information has been received from a court, public prosecutorʼs
              office, police, or other competent organization
            </ListItem>
            <ListItem>
              E. When the user in question has explicitly requested that the information be disclosed or provided to a
              third party
            </ListItem>
            <ListItem>
              F. When disclosure or provision of the information is permitted per laws and ordinances
            </ListItem>
            <ListItem>
              G. When the personal information is to be provided in conjunction with business succession due to
              circumstances such as merger and the information is handled within the scope of the purposes of use prior
              to said succession
            </ListItem>
          </List>
        </Container>
        <Container>
          <Title>Exception Clauses Concerning Provision to Third Parties</Title>
          <p>
            The Company shall bear no responsibility whatsoever concerning the obtainment of personal information by
            third parties in any of the following cases.
          </p>
          <List>
            <ListItem>
              A. When a user has used the functions of the Service or other means to disclose personal information to
              user companies (Furthermore, for information regarding how a user company handles personal information,
              please directly contact the user company in question.)
            </ListItem>
            <ListItem>
              B. When information input into the service unexpectedly identifies the user in question
            </ListItem>
            <ListItem>
              C. When personal information is provided or used by users on external websites linked to the Service
            </ListItem>
            <ListItem>
              D. When a person other than the user in question has obtained information that can be used to identify the
              user in question (ID, password, etc.)
            </ListItem>
          </List>
        </Container>
        <Container>
          <Title>Outsourcing of Personal Information Processing</Title>
          <p>
            The Company may outsource, in part or in whole, the duties for handling personal information. Moreover, the
            Company shall bear all responsibility for the handling of personal information by the outsourcee.
          </p>
        </Container>
        <Container>
          <Title>Use of Data That Has Been Statistically Processed</Title>
          <p>
            The Company may create statistical data, that has been modified so as to not identify users, based on
            personal information provided to the Company. The Company shall be able to use, without restriction,
            statistical data that does not identify users.
          </p>
        </Container>
        <Container>
          <Title>Changes, Etc. to Personal Information</Title>
          <p>
            In principle, only the user in question shall be able to request the disclosure, correction, addition,
            deletion, suspension of use, or suspension of provision to third parties (hereinafter “change, etc. to
            personal information”) of personal information notified or registered for “Purposes of Use of Personal
            Information”. Please contact the department in charge of inquiries about personal information management
            below for information about the specific methods for making such changes. However changes to personal
            information will not be provided in the following cases.
          </p>
          <List>
            <ListItem>
              A. There is a risk of harm to the life, person, assets, or other rights/interests of the user in question
              or of a third party
            </ListItem>
            <ListItem>
              B. There is a risk of an obvious hindrance to the proper operation of the Service
            </ListItem>
            <ListItem>
              C. There is a violation of other laws or ordinances
            </ListItem>
          </List>
          <p>
            Also, in the event that a change, etc. to personal information requires payment of substantial fees or in
            the event that it is difficult to implement the change, etc. to personal information and substitute measures
            must be taken to protect the rights/interests of the user, the change, etc. to personal information might
            not be performed.
          </p>
        </Container>
        <Container>
          <Title>Accuracy of Personal Information</Title>
          <p>
            The Company works to process data of provided personal information accurately. However, users shall bear all
            responsibility for keeping the contents of provided information accurate and up to date.
          </p>
        </Container>
        <Container>
          <Title>Subtle Limits to Obtaining Personal Information</Title>
          <p>
            The Company, in principle, shall not obtain personal information that includes any of the following.
            However, this does not apply in the event that a user has provided such information.
          </p>
          <List>
            <ListItem>
              A. Items concerning ideas, beliefs, or religion
            </ListItem>
            <ListItem>
              B. Items such as race, ethnicity, lineage, permanent domicile (excluding information about prefecture,
              state, region, territory, etc.), physical/mental impairments, criminal history, or other information that
              could be used as grounds for social discrimination
            </ListItem>
            <ListItem>
              C. Items concerning the rights of workers to organize, collective bargaining, and other organizational
              behavior
            </ListItem>
            <ListItem>
              D. Items concerning the participation in group demonstrations, exercise of right to petition, and
              execution of political rights
            </ListItem>
            <ListItem>
              E. Health and sexual activity
            </ListItem>
          </List>
        </Container>
        <Container>
          <Title>Identity Verification</Title>
          <p>
            The Company uses information that allows an individual to be identified (such as name, address, telephone
            number, date of birth, e-mail address, member number, and password) in order to perform identity
            verification when users perform member registration for web services, when members use the Service, and when
            the Company responds to requests to disclose, correct, delete, or suspend use of personal information.
            However, in the event that a person other than the person in question has acquired and used information that
            allows the person to be identified, the Company shall bear no responsibility whatsoever.
          </p>
        </Container>
        <Container>
          <Title>
            Obtainment and Use of Attribute Information, Device Information, Location Information, Behavior History, Etc.
          </Title>
          <List>
            <ListItem>
              With regards to cookies for attribute information, device information, location information, and behavior history, etc. (hereinafter “behavior history, etc.”)<br/>
              The Company uses cookies to protect user privacy, improve convenience, transmit advertisements, and
              obtain statistical data. Also, the Company may use technologies such as cookies and JavaScript to
              obtain, from the information provided, attribute information that does not allow users to be identified,
              such as age, gender, occupation, location (limited to information that does not allow users to be
              identified even when the information in question is used in combination), device information, user
              behavior history on the Service (URLs, content, references, etc. accessed) and location information
              according to user permission/application when using a smartphone or similar device. However, personal
               information is not included in cookies and behavior history, etc. Also, the Service uses a behavior
              targeting advertisement service in order to transmit the appropriate advertisements to users. (Opted-out
              functions may not be able to be used when the Service is accessed from mobile telephones.)
            </ListItem>
            <ListItem>
              About access logs, etc. for behavior history, etc. in the following cases<br/>
              The Company, after a user has logged in to use the service and their identity has been ascertained, may
              use the behavior history, etc. from before the log-in in question to transmit and display advertisements
              and content and to provide the Service. To stop receiving such advertisements, please contact the
              department in charge of personal information management listed below.
            </ListItem>
          </List>
        </Container>
        <Container>
          <Title>Person Responsible for Management of Personal Information</Title>
          <MarginText>INVADE Co., Ltd.</MarginText>
          <MarginText>Corporate Executive Office in Charge of the Service</MarginText>
          <MarginText><a href="mailto:beauty-info@kamisma.com">Click here</a> for inquiries about personal information</MarginText>
          <MarginText>* Before contacting us by telephone, please be aware that telephone calls may be recorded so that we can obtain an accurate account of the inquiry.</MarginText>
        </Container>
        <Container>
          <Title>Changes to Privacy Policy</Title>
          <p>
            The Company shall, except where stipulated by laws and ordinances, make changes the privacy policy where
            necessary.
          </p>
        </Container>
      </Section>
    </>
  )
}

export default PrivacyPolicy_EN

const Title = styled.h2`
  margin: 0;
  font-size: 36px;
  font-weight: bold;
  line-height: 54px;
`

const List = styled.ul`
  margin: 24px;
`

const ListItem = styled.li`
  margin: 12px;
`

const MarginText = styled.div`
  margin: 10px 0px;
`
